<div class="flex flex-middle">
    <div class="ratio-1-1"
         [style.width.em]="1.75">
        <img class="rf"
             [image]="'/assets/images/icon-finance.svg'">
    </div>
    <div class="p-l">
        <p class="s2">{{ ('0% Finance Available' + (isDiningChair ? ' Over £500' : '')) | translate }}
        </p>
        <p class="c2 flex flex-middle">
            <span class="col-11 p-r-1">{{ 'or Low Deposit Credit from' | translate }}</span>
            <price class="col-11 inline-block"
                   [value]="financeFrom"
                   [precision]="2" />
            <span class="col-11 p-r-1">/pcm*</span>
            @if (isDiningChair) {
            <span class="col-11 p-r-1">for 4 chairs</span>
            }
            <button [iCmsModalOpen]="'v12RetailFinanceDetailsModal'"
                    [iCmsModalOpenData]="{ amount: amount }"
                    class="inline-flex">
                <i class="icon-information inline-flex col-11"
                   aria-hidden="true"
                   [style.font-size.rem]="1.4"></i>
            </button>
        </p>
    </div>
</div>
